import { render, staticRenderFns } from "./LmMailTemplateNewOrEdit.vue?vue&type=template&id=07339b41"
import script from "./LmMailTemplateNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmMailTemplateNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports